import { render, staticRenderFns } from "./PatternProperties.vue?vue&type=template&id=70799a40&scoped=true"
import script from "./PatternProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatternProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PatternProperties.vue?vue&type=style&index=0&id=70799a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70799a40",
  null
  
)

export default component.exports